<template>
	<v-form ref="formIdentificacaoEmpregador" fast-fail :disabled="formDesabilitado || loading" @submit.prevent="salvaIdentificacaoEmpregador">
		<v-row>
			<v-col cols="12">
				<div class="radio">
					<div class="mt-2 mr-6"><span class="required">* </span>Tipo de Identificação</div>
					<v-radio-group inline v-model="form.tipoIdentificacao" :rules="validarIdentificacaoEmpregador.tipoIdentificacao">
						<v-radio v-for="tipo in listaTipoIdentificacao" :key="tipo.value" :label="tipo.label" :value="tipo.value" @click="resetFormConsulta" />
					</v-radio-group>
				</div>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Número de Identificação</div>
				<v-mask-input v-model="form.numeroIdentificacao" :mask="mascaraNumIdentificacao" :error-messages="erroDocumento" :rules="validarIdentificacaoEmpregador.numeroIdentificacao(form.tipoIdentificacao || 'CNPJ')" @blur="buscaNumeroIdentificacao"/>
			</v-col>
			<v-col v-if="segundaParteForm" cols="12" md="6" :style="form.tipoIdentificacao === 'CNPJ' ? '' : 'align-content: center;'">
				<div v-if="!razaoRetornoBase">
					<div class="mb-2 mr-6">Razão Social</div>
					<v-text-field v-model="form.razaoSocial" :rules="validarIdentificacaoEmpregador.razaoSocial" :disabled="formDesabilitado || bloqueiaCampos.razaoSocial"/>
				</div>
				<div v-else class="mt-7">
					<v-icon v-if="form.razaoSocial" size="30">{{ form.tipoIdentificacao === "CNPJ" ? "mdi-domain" : "mdi-account-outline" }}</v-icon>
					<span class="ml-1 mt-1">{{ form.razaoSocial }}</span>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="segundaParteForm">
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>CEP</div>
				<v-mask-input v-model="form.cep" mask="##.###-###" :rules="validarIdentificacaoEmpregador.cep" :disabled="formDesabilitado || bloqueiaCampos.cep" @blur="buscaCep"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>UF</div>
				<v-combobox v-model="form.uf" :items="listaUFs" item-title="nomeCompleto" item-value="siglaUF" :rules="validarIdentificacaoEmpregador.uf" :disabled="formDesabilitado || bloqueiaCampos.uf || !listaUFs.length"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Município</div>
				<v-combobox v-model="form.cidade" :items="listaCidades" item-title="nomeCompleto" item-value="codMunicipioRfb" :rules="validarIdentificacaoEmpregador.cidade" :loading="loadingCidade" :disabled="formDesabilitado || loadingCidade || bloqueiaCampos.cidade || !listaCidades.length"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>Tipo Logradouro</div>
				<v-combobox v-model="form.tipoLogradouro" :items="listaTipoLogradouro" item-title="descricao" item-value="id" :rules="validarIdentificacaoEmpregador.tipoLogradouro" :disabled="formDesabilitado || bloqueiaCampos.tipoLogradouro"/>
			</v-col>
			<v-col cols="12" md="4">
				<div class="mb-2 mr-6"><span class="required">* </span>Endereço</div>
				<v-text-field v-model="form.logradouro" :rules="validarIdentificacaoEmpregador.logradouro" :disabled="formDesabilitado || bloqueiaCampos.logradouro"/>
			</v-col>
			<v-col cols="12" md="2">
				<div class="mb-2 mr-6"><span class="required">* </span>Número</div>
				<v-text-field v-model="form.numero" :rules="validarIdentificacaoEmpregador.numero" :disabled="formDesabilitado || bloqueiaCampos.numero"/>
			</v-col>
			<v-col cols="12" md="3">
				<div class="mb-2 mr-6"><span class="required">* </span>Bairro</div>
				<v-text-field v-model="form.bairro" :rules="validarIdentificacaoEmpregador.bairro" :disabled="formDesabilitado || bloqueiaCampos.bairro"/>
			</v-col>
			<v-col cols="12" md="12">
				<div class="mb-2 mr-6">Referência de Acesso</div>
				<v-textarea v-model="form.referenciaAcesso" :rules="validarIdentificacaoEmpregador.referenciaAcesso"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Telefone</div>
				<v-mask-input v-model="form.telefone" mask="(##) #####-####" :rules="validarIdentificacaoEmpregador.telefone" :disabled="formDesabilitado"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-4 mr-6"><span class="required">* </span>Utiliza WhatsApp neste número?</div>
				<v-radio-group inline v-model="form.utilizaWhatsApp" :rules="validarIdentificacaoEmpregador.utilizaWhatsApp">
					<v-radio v-for="item in listaUtilizaWhatsapp" :key="item.value" :label="item.label" :value="item.value" />
				</v-radio-group>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>E-mail</div>
				<v-text-field v-model="form.email" :rules="validarIdentificacaoEmpregador.email" :disabled="formDesabilitado"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Responsável pelo contato junto ao SINE</div>
				<v-text-field v-model="form.responsavelSINE" :rules="validarIdentificacaoEmpregador.responsavelSINE"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Cargo</div>
				<v-text-field v-model="form.cargo" :rules="validarIdentificacaoEmpregador.cargo"/>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-4 mr-6"><span class="required">* </span>Contratação para outro CNPJ/CAEPF</div>
				<v-radio-group inline v-model="form.outroContratante" :rules="validarIdentificacaoEmpregador.outroContratante">
					<v-radio v-for="item in listaContratacao" :key="item.value" :label="item.label" :value="item.value" />
				</v-radio-group>
			</v-col>
		</v-row>
		<v-row v-if="form.outroContratante === 'S' && segundaParteForm">
			<v-col cols="12">
				<div class="radio">
					<div class="mt-2 mr-6"><span class="required">* </span>Contratação para outro CNPJ/CAEPF</div>
					<v-radio-group inline v-model="contratante.tipoIdentificacao" :rules="validarIdentificacaoEmpregador.contratanteTipoIdentificacao">
						<v-radio v-for="tipo in listaOutroContratante" :key="tipo.value" :label="tipo.label" :value="tipo.value" @click="resetFormConsultaContratante(tipo.value)" />
					</v-radio-group>
				</div>
			</v-col>
			<v-col cols="12" md="6">
				<div class="mb-2 mr-6"><span class="required">* </span>Número de Identificação</div>
				<v-mask-input v-model="contratante.numeroIdentificacao" :error-messages="erroDocumentoContratante" :rules="validarIdentificacaoEmpregador.contratanteNumeroIdentificacao(contratante.tipoIdentificacao || 'CNPJ')" :mask="mascaraContratanteNumIdentificacao" @blur="buscaNumeroIdentificacaoContratante"/>
			</v-col>
			<v-col cols="12" md="6">
				<div v-if="!razaoRetornoBaseContratante && exibeRazao && contratante.numeroIdentificacao">
					<div class="mb-2 mr-6">Razão Social</div>
					<v-text-field v-model="contratante.razaoSocial" :rules="validarIdentificacaoEmpregador.razaoSocial" :disabled="formDesabilitado"/>
				</div>
				<div v-else-if="!erroDocumentoContratante" class="mt-10">
					<v-icon v-if="contratante.razaoSocial" size="30">{{ contratante.tipoIdentificacao === "CNPJ" ? "mdi-domain" : "mdi-account-outline" }}</v-icon>
					<span class="ml-1 mt-1">{{ contratante.razaoSocial }}</span>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="!escondeBotoes">
			<v-col cols="12" align="end">
				<v-btn color="primary" type="submit" :loading="loading" :disabled="desabilitaAvancar">
					{{ modoSolicitacao ? "SALVAR" : "AVANÇAR" }}
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { validarIdentificacaoEmpregador } from '@/utils/ValidacoesUtils';
import { listarMunicipios, listarTipoLogradouro, listarUfs } from '@/services/ConsultaEntidadeService';
import { consultaCPF } from '@/services/RFBService';
import { buscarCep } from '@/services/EnderecosService';
import { carregar as consultaCNPJ } from '@/services/EmpresaService';
import { useRoute, useRouter } from 'vue-router'
import { cadastrarVaga, editarVaga } from '@/services/VagaService';
import { vagasEnum } from '@/utils/VagaUtils';
import { ErroAlert } from "@/utils/AlertUtils.js";
import { useStore } from "vuex"

const store = useStore();
const route = useRoute();
const router = useRouter();
const emit = defineEmits(["proximoPasso"]);
const props = defineProps({
	empregadorForm: Object,
	empregadorFormContratante: Object,
	dataVaga: Object,
	formDesabilitado: Boolean,
	escondeBotoes: Boolean,
	modoSolicitacao: Boolean,
});

const listaTipoIdentificacao = [
	{ label: "CNPJ", value: "CNPJ" },
	{ label: "CAEPF", value: "CAEPF" },
	{ label: "CPF", value: "CPF" },
]

const listaOutroContratante = [
	{ label: "CNPJ", value: "CNPJ" },
	{ label: "CAEPF", value: "CAEPF" },
]

const listaUtilizaWhatsapp = [
	{ label: "Sim", value: "S" },
	{ label: "Não", value: "N" },
]

const listaContratacao = [
	{ label: "Não", value: "N" },
	{ label: "Sim, informar contratante", value: "S" },
]

const loading = ref(false);
const loadingCidade = ref(false);
const editando = ref(false);
const razaoRetornoBase = ref(false);
const exibeRazao = ref(false);
const razaoRetornoBaseContratante = ref(false);
const podeExibirSegundaParte = ref(false);
const erroDocumento = ref();
const erroDocumentoContratante = ref();
const segundaParteForm = computed(() => {
	if (!podeExibirSegundaParte.value) {
		return false;
	}
	if (!form.value.numeroIdentificacao) {
		podeExibirSegundaParte.value = false;
		return false;
	}
	if (form.value.tipoIdentificacao === "CNPJ" && form.value.numeroIdentificacao.length < 14) {
		podeExibirSegundaParte.value = false;
		return false;
	}
	if (form.value.tipoIdentificacao !== "CNPJ" && form.value.numeroIdentificacao.length < 11) {
		podeExibirSegundaParte.value = false;
		return false;
	}
	return true;
});
const formIdentificacaoEmpregador = ref();
const bloqueiaCampos = ref({
	tipoIdentificacao: false,
	numeroIdentificacao: false,
	razaoSocial: false,
	logradouro: false,
	numero: false,
	bairro: false,
	cep: false,
	uf: false,
	cidade: false,
	tipoLogradouro: false,
	referenciaAcesso: false,
	telefone: false,
	utilizaWhatsApp: false,
	email: false,
	responsavelSINE: false,
	cargo: false,
	outroContratante: false,
});
const form = ref({
	id: editando ? Number(route.params?.id) : undefined,
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
	logradouro: "",
	numero: "",
	bairro: "",
	cep: "",
	uf: "",
	cidade: "",
	tipoLogradouro: undefined,
	referenciaAcesso: "",
	telefone: "",
	utilizaWhatsApp: undefined,
	email: "",
	responsavelSINE: "",
	cargo: "",
	outroContratante: undefined,
});

const listaUFs = ref([]);
const listaCidades = ref([]);
const listaTipoLogradouro = ref([]);

const contratante = ref({
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
});

// CNPJ alfanumérico: token N do VMaskInput aceita [0-9A-Z] e converte para maiúscula;
// os 2 dígitos verificadores (##) continuam numéricos.
const MASCARA_INPUT_CNPJ = "NN.NNN.NNN/NNNN-##";
const MASCARA_INPUT_CPF = "###.###.###-##";

const mascaraNumIdentificacao = computed(() => {
	return form.value.tipoIdentificacao === "CNPJ" ? MASCARA_INPUT_CNPJ : MASCARA_INPUT_CPF;
})

const mascaraContratanteNumIdentificacao = computed(() => {
	return contratante.value.tipoIdentificacao === "CNPJ" ? MASCARA_INPUT_CNPJ : MASCARA_INPUT_CPF;
})

const desabilitaAvancar = computed(() => {
	const ignorarCampos = ["id", "razaoSocial", "referenciaAcesso"]
	const formValido = Object.keys(form.value).every(key => {
		if (ignorarCampos.includes(key)){
			return true;
		}
		if (key === "outroContratante" && form.value[key] === "S") {
			return Object.keys(contratante.value).every(key => {
				if (ignorarCampos.includes(key)){
					return true;
				}
				return !!contratante.value[key] && contratante.value[key] !== "";
			});
		}
		return !!form.value[key] && form.value[key] !== "";
	});
	let contemErro = false;
	if (formIdentificacaoEmpregador.value) {
		contemErro = !!formIdentificacaoEmpregador.value.errors.length
	}
	return !formValido || contemErro;
});

function resetFormConsulta(tipo, cnpj) {
	form.value = {
		id: editando ? Number(route.params?.id) : undefined,
		tipoIdentificacao: tipo ? tipo : form.value.tipoIdentificacao,
		numeroIdentificacao: cnpj ? cnpj : "",
		razaoSocial: "",
		logradouro: "",
		numero: "",
		bairro: "",
		cep: "",
		uf: "",
		cidade: "",
		tipoLogradouro: undefined,
		referenciaAcesso: "",
		telefone: "",
		utilizaWhatsApp: undefined,
		email: "",
		responsavelSINE: "",
		cargo: "",
		outroContratante: undefined,
	}
	contratante.value = {
		tipoIdentificacao: "CNPJ",
		numeroIdentificacao: "",
		razaoSocial: "",
	}
	bloqueiaCampos.value = {
		tipoIdentificacao: false,
		numeroIdentificacao: false,
		razaoSocial: false,
		logradouro: false,
		numero: false,
		bairro: false,
		cep: false,
		uf: false,
		cidade: false,
		tipoLogradouro: false,
		referenciaAcesso: false,
		telefone: false,
		utilizaWhatsApp: false,
		email: false,
		responsavelSINE: false,
		cargo: false,
		outroContratante: false,
	};
}

function resetFormConsultaContratante(tipo) {
	contratante.value = {
		tipoIdentificacao: tipo,
		numeroIdentificacao: "",
		razaoSocial: "",
	}
}

async function salvaIdentificacaoEmpregador() {
	if (props.formDesabilitado) {
		emit("proximoPasso");
		return;
	}
	await formIdentificacaoEmpregador.value.validate();
	if (!formIdentificacaoEmpregador.value.isValid) {
		return;
	}
	const bodyRequest = ref({
		id: editando.value ? Number(form.value.id) : undefined,
		stepCadastroVaga: vagasEnum[0],
		empregador: {
			id: null,
			tipoIdentificacao: form.value.tipoIdentificacao,
			numeroIdentificacao: form.value.numeroIdentificacao,
			razaoSocial: form.value.razaoSocial,
			cargo: form.value.cargo,
			endereco: {
				id: null,
				logradouro: form.value.logradouro,
				numero: form.value.numero,
				bairro: form.value.bairro,
				cep: form.value.cep,
				municipio: form.value.cidade,
				numero: form.value.numero,
				tipoLogradouro: form.value.tipoLogradouro,
				referenciaAcesso: form.value.referenciaAcesso,
			},
			contato: {
				telefone: form.value.telefone,
				utilizaWhatsApp: form.value.utilizaWhatsApp,
				email: form.value.email,
				responsavelSINE: form.value.responsavelSINE,
			},
		},
		outroContratante: form.value.outroContratante,
		contratante: {
			id: null,
			tipoIdentificacao: form.value.outroContratante === "N" ? undefined : contratante.value.tipoIdentificacao,
			numeroIdentificacao: form.value.outroContratante === "N" ? undefined : contratante.value.numeroIdentificacao,
			razaoSocial: form.value.outroContratante === "N" ? undefined : contratante.value.razaoSocial,
		}
	});
	if (!editando.value) {
		loading.value = true;
		await cadastrarVaga({
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(({ data }) => {
				router.push(`/vagas/${data.id}`);
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao salvar identificação do empregador. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
	else {
		loading.value = true;
		await editarVaga(bodyRequest.value.id || 0,
			{
				...props.dataVaga,
				...bodyRequest.value,
			})
			.then(() => {
				emit("proximoPasso");
			})
			.catch((error) => {
				ErroAlert({ mensagem: "Ocorreu um erro ao editar identificação do empregador. Tente novamente mais tarde!", error });
			})
			.finally(() => loading.value = false);
	}
}
async function buscaNumeroIdentificacao() {
	await formIdentificacaoEmpregador.value.validate();
	if (formIdentificacaoEmpregador.value.items[1].isValid) {
		if (form.value.tipoIdentificacao === "CNPJ") {
			loading.value = true;
			await consultaCNPJ(form.value.numeroIdentificacao)
				.then(({ data }) => {
					form.value.razaoSocial = data.nome;
					razaoRetornoBase.value = !!form.value.razaoSocial;

					if (data.endereco) {
						form.value.cep = data.endereco?.cep ? data.endereco?.cep : undefined;

						if (data.endereco.municipio) {
							form.value.cidade = data.endereco?.municipio;
							form.value.uf = data.endereco?.municipio?.uf ? data.endereco?.municipio?.uf : undefined;
						}
						form.value.tipoLogradouro = data.endereco?.tipoLogradouro ? data.endereco?.tipoLogradouro : undefined
						form.value.logradouro = data.endereco?.nomeLogradouro ? data.endereco.nomeLogradouro : undefined;
						form.value.numero = data.endereco?.numeroLogradouro ? data.endereco?.numeroLogradouro : undefined;
						form.value.bairro = data.endereco?.bairro ? data.endereco?.bairro : undefined;
					}

					if (data.contatoEmpresa) {

						if (data.contatoEmpresa.telefones) {
							form.value.telefone = data.contatoEmpresa.telefones.length ? data.contatoEmpresa.telefones[0].numeroFormatado : "";
						}
						form.value.email = data.contatoEmpresa.email ? data.contatoEmpresa.email : undefined;
					}

					bloqueiaCampos.value.razaoSocial = !!form.value.razaoSocial;
					bloqueiaCampos.value.cep = !!form.value.cep;
					bloqueiaCampos.value.cidade = !!form.value.cidade;
					bloqueiaCampos.value.uf = !!form.value.uf;
					bloqueiaCampos.value.tipoLogradouro = !!form.value.tipoLogradouro;
					bloqueiaCampos.value.logradouro = !!form.value.logradouro;
					bloqueiaCampos.value.numero = !!form.value.numero;
					bloqueiaCampos.value.bairro = !!form.value.bairro;
					bloqueiaCampos.value.telefone = !!form.value.telefone;
					bloqueiaCampos.value.email = !!form.value.email;
					podeExibirSegundaParte.value = true;
				})
				.catch((error) => {
					resetFormConsulta(form.value.tipoIdentificacao, form.value.numeroIdentificacao);
					razaoRetornoBase.value = !!form.value.razaoSocial;
					podeExibirSegundaParte.value = false;
					erroDocumento.value = error.response.data.mensagem;
					ErroAlert({ mensagem: error.response.data.mensagem, error });
				})
				.finally(() => loading.value = false);
		}
		else {
			loading.value = true;
			await consultaCPF(form.value.numeroIdentificacao)
				.then(({ data }) => {
					form.value.razaoSocial = data.nome;
					razaoRetornoBase.value = !!form.value.razaoSocial;
					podeExibirSegundaParte.value = true;
				})
				.catch((error) => {
					podeExibirSegundaParte.value = false;
					erroDocumento.value = "CPF não localizado na base, por favor insira um CPF valido.";
					ErroAlert({ mensagem: "CPF não localizado na base, por favor insira um CPF valido.", error });
				})
				.finally(() => loading.value = false);
		}
	}
}

async function buscaCep() {
	if (validarIdentificacaoEmpregador.cep[1](form.value.cep) === true) {
		loading.value = true;
		await buscarCep(form.value.cep)
			.then(({ data }) => {
				form.value.uf = listaUFs.value.find((uf) => uf.sigla === data.municipio.uf.siglaUf);
				bloqueiaCampos.value.uf = !!form.value.uf;

				form.value.cidade = data.municipio;
				bloqueiaCampos.value.cidade = !!form.value.cidade;

				form.value.tipoLogradouro = data.tipoLogradouro.codigo ? data.tipoLogradouro : undefined;
				bloqueiaCampos.value.tipoLogradouro = !!form.value.tipoLogradouro;

				form.value.logradouro = data.logradouro;
				bloqueiaCampos.value.logradouro = !!form.value.logradouro;

				form.value.bairro = data.bairro;
				bloqueiaCampos.value.bairro = !!form.value.bairro;
			})
			.catch((error) => {
				ErroAlert({ mensagem: error.response.data.mensagem, error });
				form.value.uf = undefined;
				form.value.cidade = undefined;
				form.value.numero = undefined;
				form.value.logradouro = undefined;
				form.value.tipoLogradouro = undefined;
				form.value.bairro = undefined;
				bloqueiaCampos.value.uf = false;
				bloqueiaCampos.value.cidade = false;
				bloqueiaCampos.value.tipoLogradouro = false;
				bloqueiaCampos.value.logradouro = false;
				bloqueiaCampos.value.bairro = false;
			})
			.finally(() => loading.value = false);
	}
}

async function buscaNumeroIdentificacaoContratante() {
	if (validarIdentificacaoEmpregador.contratanteNumeroIdentificacao(contratante.value.tipoIdentificacao)[1](contratante.value.numeroIdentificacao) === true) {
		if (contratante.value.tipoIdentificacao === "CNPJ") {
			loading.value = true;
			await consultaCNPJ(contratante.value.numeroIdentificacao)
				.then(({ data }) => {
					contratante.value.razaoSocial = data.nome;
					razaoRetornoBaseContratante.value = !!contratante.value.razaoSocial;
					exibeRazao.value = true;
				})
				.catch((error) => {
					exibeRazao.value = false;
					razaoRetornoBaseContratante.value = false;
					erroDocumentoContratante.value = error.response.data.mensagem;
					ErroAlert({ mensagem: error.response.data.mensagem, error });
				})
				.finally(() => loading.value = false);
		}
		else {
			loading.value = true;
			await consultaCPF(contratante.value.numeroIdentificacao)
				.then(({ data }) => {
					contratante.value.razaoSocial = data.nome;
					razaoRetornoBaseContratante.value = !!contratante.value.razaoSocial;
					exibeRazao.value = true;
				})
				.catch((error) => {
					exibeRazao.value = false;
					erroDocumentoContratante.value = "CPF não localizado na base, por favor insira um CPF valido.";
					ErroAlert({ mensagem: "CPF não localizado na base, por favor insira um CPF valido.", error });
				})
				.finally(() => loading.value = false);
		}
	}
	else {
		razaoRetornoBaseContratante.value = false;
		contratante.value.razaoSocial = "";
	}
}

async function buscaUF() {
	if (store.getters["entidades/getListaUFs"].length) {
		listaUFs.value = store.getters["entidades/getListaUFs"];
		return;
	}
	await listarUfs()
		.then(({ data }) => {
			listaUFs.value = data;
			store.commit("entidades/setListaUFs", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}
async function buscaCidades() {
	loadingCidade.value = true;
	await listarMunicipios(form.value.uf.siglaUf)
		.then(({ data }) => {
			listaCidades.value = data;
			if (form.value.cidade && form.value.cidade.codMunicipioRfb) {
				form.value.cidade = listaCidades.value.find((cidade) => form.value.cidade.codMunicipioRfb === cidade.codMunicipioRfb);
			}
			else {
				form.value.cidade = undefined;
			}
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		})
		.finally(() => loadingCidade.value = false);
}

async function buscaTipoLogradouro() {
	if (store.getters["entidades/getListaTipoLogradouro"].length) {
		listaTipoLogradouro.value = store.getters["entidades/getListaTipoLogradouro"];
		return;
	}
	await listarTipoLogradouro()
		.then(({ data }) => {
			listaTipoLogradouro.value = data;
			store.commit("entidades/setListaTipoLogradouro", data);
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

watch(() => props, () => {
	form.value = props.empregadorForm;
	razaoRetornoBase.value = !!form.value.razaoSocial,
	contratante.value = props.empregadorFormContratante;
	razaoRetornoBaseContratante.value = !!contratante.value.razaoSocial;
}, { deep: true, immediate: true });

watch(() => form.value.numeroIdentificacao, () => {
	erroDocumento.value = undefined;
});

watch(() => form.value.uf, async (newValue, oldValue) => {
	if (!newValue) {
		return;
	}
	if (newValue === oldValue) {
		return;
	}
	await buscaCidades();
});

watch(() => contratante.value.numeroIdentificacao, () => {
	erroDocumentoContratante.value = undefined;
	contratante.value.razaoSocial = undefined;
});

onMounted(async () => {
	await buscaUF();
	await buscaTipoLogradouro();
	if (!isNaN(route.params?.id)) {
		editando.value = true;
		podeExibirSegundaParte.value = true;
	}
});
</script>
<style lang="css" scoped>
.radio {
	display: inline-flex;
}
.required {
	color: red;
}
</style>
